module.exports = __webpack_public_path__ + "static/media/NotificationsFlatline.d134b75a.png";